import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { useRevealOnScroll } from "../../hooks/useRevealOnScroll";
import SectionIntro from "../../components/SectionIntro/SectionIntro";

const AboutUsSection = () => {
  const { t } = useTranslation();
  const revealRef = useRevealOnScroll({ threshold: 0.08 });

  return (
    <section
      id="about-heading"
      className="section-n section--about section--en vh-about"
      aria-labelledby="about-heading-title"
    >
      <div ref={revealRef} className="container-n reveal">
        <div className="vh-about__layout pr-big">
          <a className="skip-the-section link-n" href="#panel-9-0-0-2">
            <span className="link-n__text">{t("skip.section")}</span>
          </a>

          <header className="vh-about__header">
            <SectionIntro eyebrow={t("about.eyebrow")}>
              <h2
                id="about-heading-title"
                className="section__title title-h2 vh-section-title vh-about__title"
              >
                {t("about.title")}
              </h2>
            </SectionIntro>
            <p className="vh-about__lead description-n">{t("about.lead")}</p>
            <p className="vh-about__para description-n">{t("about.p1")}</p>
            <p className="vh-about__para description-n">{t("about.p2")}</p>
          </header>
        </div>
      </div>
    </section>
  );
};

export default memo(AboutUsSection);
